import * as imagesLoaded from 'imagesloaded'
import common from './common'
import index from './index'
import template from './template'
import faq from './faq'
import product from './product'
import sample from './sample'
import partials from './partials'

document.addEventListener('DOMContentLoaded', function() {
  imagesLoaded(document.getElementById('app'), () => {
    partials().then(() => {
      common()
      index()
      template()
      faq()
      sample()
      product()
      initContactForm()
      require("fslightbox")
      window.addEventListener('resize', setViewport)
      window.addEventListener('load', setViewport)


      const c = document.querySelectorAll('.colsimulator__box__grid__list li')
      c.forEach((el) => {
        const d = el.querySelector('img')
        const a = el.querySelector('a')
        a.href = d.src
      })

      // STG用にリンクを一括チェック、置き換え
      setTimeout(()=> {
        if (!location.pathname.startsWith('/stg/')) return;
        var anchors = document.querySelectorAll('#app a[href]');
        anchors.forEach(function(el) {
            var href = el.getAttribute('href');
            if (href && href.startsWith('/') && !href.startsWith('/stg/')) {
                el.setAttribute('href', '/stg' + href);
            }
        });
        var forms = document.querySelectorAll('#app form[action]');
        forms.forEach(function(f) {
            var action = f.getAttribute('action');
            if (action && action.startsWith('/') && !action.startsWith('/stg/')) {
                f.setAttribute('action', '/stg' + action);
            }
        });
      },400)

    })
  })
})


function initContactForm() {
  setTimeout(()=>{
    const cf_selector = 'div.wpcf7 > form'
    const cf_forms = document.querySelectorAll(cf_selector)
    
    if (cf_forms.length > 0) {
      const cf_load = document.querySelector('.wpcf7-spinner')
      cf_load.remove()
      window.wpcf7.init(cf_forms[0])
    }
  },1000)
}


function setViewport(){
  const vw = window.innerWidth;
  const vh = window.innerHeight * 0.01
  const headApp = document.getElementById('header-app')
  const head = document.getElementById('site-header')
  document.documentElement.style.setProperty('--vh', `${vh}px`)
  document.documentElement.style.setProperty('--vw', `${vw}px`)
  if(vw < 769){ document.documentElement.style.setProperty('--size', '10px') }
  else if(vw < 1025){ document.documentElement.style.setProperty('--size', '16px') }
  else{ document.documentElement.style.setProperty('--size', '32px') }

  if(head){
    const headSize = head.getBoundingClientRect().height
    document.documentElement.style.setProperty('--head', `${headSize}px`)
  }
  if(headApp){
    const headAppSize = headApp.getBoundingClientRect().height
    document.documentElement.style.setProperty('--headapp', `${headAppSize}px`)
  }
}